import builder from '@rsql/builder';
import { InputText } from 'primereact/inputtext';
import React, { useRef } from 'react';
import RotuloSeplag from '../../../../components/rotuloSeplag/RotuloSeplag';
import Pages from '../../../../config/Pages';
import ConfirmDialog from '../../../../core/components/ConfirmDialog';
import InputDropDown from '../../../../core/components/inputs/inputDropDown/InputDropDown';
import BasePage from '../../../../core/page/BasePage';
import BaseFilter from '../../../../core/page/components/baseFilter/BaseFilter';
import AnalisePropostaMetaService from '../../../../service/AnalisePropostaMetaService';
import SituacaoAvaliacaoMetaService from '../../../../service/SituacaoAvaliacaoMetaService';
import { inputsAnalisePropostaMeta } from '../PageInputs';
import AfterActionsButtons from '../components/AfterActionsButtons';

function AnalisePropostaMeta() {
    const confirmRef = useRef(null);
    const Inputs = ({ formik }) => (
        <>
            <RotuloSeplag nome="Usuário de Solicitação" cols="12 3 4">
                <InputText
                    name="usuarioDeSolicitacao"
                    value={formik.values?.usuarioDeSolicitacao}
                    onChange={formik.handleChange}
                />
            </RotuloSeplag>

            <RotuloSeplag nome="Analista Negocial" cols="12 3 4">
                <InputText
                    name="analistaNegocial"
                    value={formik.values?.analistaNegocial}
                    onChange={formik.handleChange}
                />
            </RotuloSeplag>

            <RotuloSeplag nome="Situação" cols="12 3 4">
                <InputDropDown
                    name="situacaoAvaliacaoMeta"
                    formik={formik}
                    callbackSetList={SituacaoAvaliacaoMetaService.list.bind(
                        SituacaoAvaliacaoMetaService
                    )}
                    optionLabel={'descSituacaoAvaliacaoMeta'}
                    optionValue={'codgSituacaoAvaliacaoMeta'}
                />
            </RotuloSeplag>

            <RotuloSeplag nome="Código do Indicador" cols="12 3 4">
                <InputText
                    name="codigoDoIndicador"
                    value={formik.values.codigoDoIndicador}
                    onChange={formik.handleChange}
                    keyfilter="int"
                />
            </RotuloSeplag>

            <RotuloSeplag nome="Nome do Indicador" cols="12 3 4">
                <InputText
                    name="nomeDoIndicador"
                    value={formik.values?.nomeDoIndicador}
                    onChange={formik.handleChange}
                />
            </RotuloSeplag>

            <RotuloSeplag nome="Nº da Meta" cols="12 3 4">
                <InputText
                    name="numeroDaMeta"
                    value={formik.values.numeroDaMeta}
                    onChange={formik.handleChange}
                    keyfilter="int"
                />
            </RotuloSeplag>

            <RotuloSeplag nome="Meta" cols="12 3 4">
                <InputText
                    name="metaDesc"
                    value={formik.values.metaDesc}
                    onChange={formik.handleChange}
                />
            </RotuloSeplag>
        </>
    );

    return (
        <>
            <ConfirmDialog isOk ref={confirmRef} />
            <BasePage
                service={AnalisePropostaMetaService}
                page={{
                    pageUrls: Pages.sei.analisePropostaMeta.url.list,
                    pageName: Pages.sei.analisePropostaMeta.title,
                }}
                initialValues={inputsAnalisePropostaMeta.filter(
                    (input) => input?.table?.use ?? false
                )}
                enableAdicionar={false}
                enableExcluir={false}
                enableAlterar={false}
                enableEditar={false}
                addAfterActions={(dados) => (
                    <AfterActionsButtons dados={dados} confirmRef={confirmRef} />
                )}
            >
                <BaseFilter
                    prepareInitialValues={(dados) => ({
                        ...dados,
                        situacaoAvaliacaoMeta: 'PENDENTE',
                    })}
                    initialValues={inputsAnalisePropostaMeta.filter(
                        (input) => input?.filter?.use ?? false
                    )}
                    customFilter={{
                        responsavelAnalise: ({ nameUse, original }) =>
                            builder.comparison(nameUse, '==', original?.idenPessoa),
                    }}
                >
                    <Inputs />
                </BaseFilter>
            </BasePage>
        </>
    );
}

export default AnalisePropostaMeta;
